import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserScreenWindow from "../Components/UserScreenWindow";

export default function NotPermitted() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/home");
    }, 5000);

    const interval = setInterval(() => {
      setCountdown((prevCount) => prevCount - 1);
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [navigate]);

  return (
    <UserScreenWindow label="Not Permitted">
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
        <div className="bg-white rounded-lg shadow-md p-8 max-w-md w-full text-center">
          <div className="text-red-500 text-5xl mb-4">
            <i className="fas fa-exclamation-circle"></i>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Access Denied
          </h1>
          <p className="text-gray-600 mb-6">
            You don't have permission to access this page. Please contact an
            administrator if you believe this is an error.
          </p>
          <p className="text-sm text-gray-500 mb-4">
            Redirecting to homepage in {countdown} seconds...
          </p>

          <button
            onClick={() => navigate("/home")}
            className="bg-gray-500 hover:bg-gray-600 text-white font-medium py-2 px-4 rounded transition duration-200"
          >
            Go to Home
          </button>
        </div>
      </div>
    </UserScreenWindow>
  );
}
